import { LinearProgress as MuiLinearProgress, type LinearProgressProps as MuiLinearProgressProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<MuiLinearProgressProps>;

export function LinearProgress(props: Props) {
  return <MuiLinearProgress {...props} />;
}

export type { Props as LinearProgressProps };
